import { useEffect, useContext, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    upsertTagsByVariantId,
} from "../../api/actions/actions";
import { PlaceholderContext } from "../../contexts/Contexts";
import { Dialog } from "../modal/Dialog";
import CodeErrorTemplate from "../../templates/CodeErrorTemplate";
import CollectionList from "../../widgets/CollectionList";
import VariantList from "./VariantList";
import { ReloadSvg, BoxArrowOutSvg, BoxArrowInSvg, ListCheckSvg, ListMinusSvg, DeleteSvg } from "../../icons/Icon";
import { $serializeForm } from "../../main";
import VariantDiscountInputBar from "./VariantDiscountInputBar";
import {
    selectAllVariantsEvent,
    selectNoneVariantsEvent,
} from "../../events/VariantEditorEvents";
import { fetchAllVariantsEvent } from "../../events/VariantEvents";
import { useEventContext } from "../../contexts/EventContextProvider";
import { fetchAllDiscountsEvent } from "../../events/DiscountEvents";
import {
    enableVariantDiscountsBatchEditEvent,
    disableVariantDiscountsBatchEditEvent,
    applyDiscountsToSelectedVariantsEvent,
    deleteDiscountsFromSelectedVariantsEvent,
    deleteAllDiscountsFromSelectedVariantsEvent
} from "../../events/VariantDiscountsEditorEvents";

const CustomActions = (p) => {

    const onCheckAll = () => {
        selectAllVariantsEvent(p.listRef);
    };
    const onUncheckAll = () => {
        selectNoneVariantsEvent(p.listRef);
    };
    const onApplyToSelected = () => {
        applyDiscountsToSelectedVariantsEvent(p.listRef, p.inputRef)
    }
    const onRemoveFromSelected = () => {
        deleteDiscountsFromSelectedVariantsEvent(p.listRef, p.inputRef)
    }
    const onClearAllSelected = () => {
        deleteAllDiscountsFromSelectedVariantsEvent(p.listRef);
    }
    const onReload = () => {
        fetchAllVariantsEvent(true);
    };

    return (
        <div className="CollectionList_actions">
            <button className="CollectionList_reload" onClick={onReload}><ReloadSvg /></button>
            <button className="CollectionList_ApplyToAll" onClick={onApplyToSelected}><BoxArrowInSvg /></button>
            <button className="CollectionList_RemoveFromAll" onClick={onRemoveFromSelected}><BoxArrowOutSvg /></button>
            <button className="CollectionList_RemoveFromAll" onClick={onClearAllSelected}><DeleteSvg /></button>
            <button className="CollectionList_CheckAll" onClick={onCheckAll}><ListCheckSvg /></button>
            <button className="CollectionList_UncheckAll" onClick={onUncheckAll}><ListMinusSvg /></button>
        </div >
    );
}
const VariantDiscountEditor = (p) => {

    const dispatch = useDispatch();
    const { state, eventDispatch } = useEventContext();
    const list = useRef(null);
    const inputBar = useRef(null);

    const variants = useSelector((state) => state.base.variants);
    const placeholder = useContext(PlaceholderContext);

    useEffect(() => {
        fetchAllVariantsEvent();
        fetchAllDiscountsEvent();
    }, []);

    const onEdit = (e, o) => {
        let [encoded, decoded] = $serializeForm(o);
        decoded['tags'] = decoded['tagsSelected'] || [];
        delete decoded['tagsSelected'];
        console.log('onEdit', decoded, o)
        dispatch(upsertTagsByVariantId(decoded)).unwrap()
            .then((result) => {
                if (result.content > 0) {
                    console.log('onEdit.result', result);
                }
            })
            .catch((error) => {
                console.log("Custom Error:", error, error.error);
            });
    };

    const onMultiSelected = (s) => {
        if ((Object.keys(s).length > 1)) {
            eventDispatch(enableVariantDiscountsBatchEditEvent());
        } else {
            eventDispatch(disableVariantDiscountsBatchEditEvent());
        }
    };

    return (
        <>
            <div className="page">
                <div className="flex-24">
                    <div className="col-24 flex-column">
                        <div className="page-box">
                            <div className='page-box-header'>
                                <h4><span>Discounts to variants editor</span></h4>
                            </div>
                            <div className='page-box-body'>
                                <VariantDiscountInputBar ref={inputBar} />
                                <CollectionList
                                    ref={list}

                                    selectable={true}
                                    selectAll={true}
                                    unSelectAll={false}
                                    onSelect={onMultiSelected}
                                    itemsPerPage={10}
                                    items={variants}

                                    ItemsComponent={VariantList}

                                    CustomActionsComponent={(p) => <CustomActions listRef={list} inputRef={inputBar} />}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default VariantDiscountEditor;